import React, { useState } from 'react';
import { Button } from 'antd';
import { LogoutOutlined, LockOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DevBanner, { DEV_BANNER_HEIGHT } from '../components/DevBanner';
import ChangePasswordModal from '../components/ChangePasswordModal';
import './PartnerLayout.scss';

const PartnerLayout = ({ children }) => {
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  return (
    <div className="PartnerLayout" style={DEV_BANNER_HEIGHT ? { paddingTop: DEV_BANNER_HEIGHT } : undefined}>
      <DevBanner />
      <header className="partner-header">
        <div className="partner-header-left">
          <h2 className="partner-title">OVO Partner Portal</h2>
        </div>
        <div className="partner-header-right">
          <span className="partner-user-name">{user?.name || user?.email}</span>
          <Button type="text" icon={<LockOutlined />} onClick={() => setChangePasswordOpen(true)}>
            Change Password
          </Button>
          <Button type="text" icon={<LogoutOutlined />} onClick={() => navigate('/logout')}>
            Logout
          </Button>
        </div>
      </header>
      <div className="partner-content">{children}</div>
      <ChangePasswordModal open={changePasswordOpen} onClose={() => setChangePasswordOpen(false)} />
    </div>
  );
};

export default PartnerLayout;
